import { Component, Input } from '@angular/core';
import { Day, Vehicle } from 'src/main/webapp/assets/models/iter.model';

/**ToDo Documentazione */
@Component({
  selector: 'app-recap-vehicles',
  styleUrls: ['./recap-vehicles.component.scss'],
  templateUrl: './recap-vehicles.component.html'
})
export class RecapVehiclesComponent {
  @Input() public day: Day | undefined;
  @Input() public serviceIcons: any;

  public getServiceIconPath(name: string): string | undefined {
    return this.serviceIcons ? this.serviceIcons[name] : undefined;
  }

  public getCarRecap(car: Vehicle) {
    const model = car.model?.toLowerCase();
    const pickup = car.locations.pickup[0].name?.toLowerCase();

    return `${model} (${pickup})`;
  }
}
